import { useMutation, useQuery } from '@tanstack/react-query'
import { apiClient } from 'api/apiClient/apiClient'
import type {
  BotStrategySettingResponse,
  ExportBotStrategySettingRequest,
  SyncTradeResultRequest,
} from './elplan.types'

export const TRADE_RESULT_SYNC_QUERY_KEY = 'tradeResultSync'
export const LAST_SYNC_TIME_QUERY_KEY = 'tradeResultLastSyncTime'

type SyncTradeResultResponse = {
  synced_at: string
}

type LastSyncTimeResponse = {
  synced_at: string | null
}

export function useSyncTradeResultMutation() {
  return useMutation({
    mutationFn: (data: SyncTradeResultRequest) =>
      apiClient<SyncTradeResultResponse>('elplan/intraday/sync_trade_result', {
        method: 'POST',
        data,
      }),
  })
}

export function useLastSyncTimeQuery(systemId: number | undefined, enabled: boolean) {
  return useQuery({
    queryKey: [LAST_SYNC_TIME_QUERY_KEY, systemId],
    queryFn: () =>
      apiClient<LastSyncTimeResponse>('elplan/intraday/latest_trade_result_sync', {
        params: { system_id: systemId },
      }),
    enabled: enabled && systemId !== undefined,
  })
}

export const BOT_STRATEGY_SETTING_QUERY_KEY = 'botStrategySetting'

export function useExportBotStrategySettingMutation() {
  return useMutation({
    mutationFn: (data: ExportBotStrategySettingRequest) =>
      apiClient<void>('elplan/intraday/export_bot_strategy_setting', {
        method: 'POST',
        data,
      }),
  })
}

export function useBotStrategySettingQuery(systemId: number | undefined, startTime: ISODateTime, endTime: ISODateTime) {
  return useQuery({
    queryKey: [BOT_STRATEGY_SETTING_QUERY_KEY, { systemId, startTime, endTime }],
    queryFn: () =>
      apiClient<BotStrategySettingResponse>('elplan/intraday/bot_strategy_setting', {
        params: { system: systemId, start_time: startTime, end_time: endTime },
      }),
    enabled: systemId !== undefined,
  })
}
